<template>
  <div class="homepage-2">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection :data="hero" />
      <FeatureSection :data="features" />
      <DiscoverSection :data="discover" />
      <ComparisonSection :data="comparison" />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/hero'
import FeatureSection from '../components/FeatureSection/feature'
import DiscoverSection from '../components/DiscoverSection/discover'
import FooterSection from '../components/FooterSection/footerOne'
import ComparisonSection from '../components/ComparisonSection/comparison'

export default {
  name: 'PageTurnkeyWeb',
  components: {
    ScrollupSection,
    HeaderSection,
    ComparisonSection,
    HeroSection,
    FeatureSection,
    DiscoverSection,
    FooterSection
  },
  data () {
    return {
      hero: {
        image: 'assets/img/player.png',
        title: 'SourceSync works with all players.',
        text: 'Adding one-line of code to your site, turnkey-web can automatically find and overlay any videos you configure. Using patented technology, we connect the video your users decide to play with relevant smart content on our platform that matches criteria you specify.',
        bottomText: 'Don\'t have an existing player on your site? Check out "Turnkey Player", which is our own player.'
      },
      comparison: {
        title: 'Supported Players',
        text: 'Turnkey Web will automatically detect the following players and support the following features, including analytics and sycnronization. More player support is comming soon!',
        gray: true,
        plans: [{
          name: 'Plyr.io',
          id: 'plyr',
          action: {
            url: '/players?player=',
            text: 'See Examples'
          },
          features: [
            { text: 'Play/Pause/Seek/RW/FF', supported: true},
            { text: 'Volume Up/Down', supported: true},
            { text: 'Full Screen', supported: true},
            { text: 'Picture In Picture', supported: true},
            { text: 'Streaming', supported: true},
            { text: 'Play speed 0.5x to 2x', supported: true},
            { text: 'Closed Captioning', supported: true},
            { text: 'Mobile support', supported: true},
            { text: 'Ad (Pre/Midroll) detection', supported: true},
            { text: 'Audio Fingerprinting', supported: true},
            { text: 'AI video processing', supported: true}
          ]
        },
        {
          name: 'Video JS',
          id: 'videojs',
          action: {
            url: '/players?player=',
            text: 'See Examples'
          },
          features: [
            { text: 'Play/Pause/Seek/RW/FF', supported: true},
            { text: 'Volume Up/Down', supported: true},
            { text: 'Full Screen', supported: true},
            { text: 'Picture In Picture', supported: true},
            { text: 'Streaming', supported: true},
            { text: 'Play speed 0.5x to 2x', supported: true},
            { text: 'Closed Captioning', supported: true},
            { text: 'Mobile support', supported: true},
            { text: 'Ad (Pre/Midroll) detection', supported: true},
            { text: 'Audio Fingerprinting', supported: false},
            { text: 'AI video processing', supported: false}
          ]
        },
        {
          name: 'Rumble Player',
          id: 'rumble',
          action: {
            url: '/players?player=',
            text: 'See Examples'
          },
          features: [
            { text: 'Play/Pause/Seek/RW/FF', supported: true},
            { text: 'Volume Up/Down', supported: true},
            { text: 'Full Screen', supported: true},
            { text: 'Picture In Picture', supported: false},
            { text: 'Streaming', supported: false},
            { text: 'Play speed 0.5x to 2x', supported: false},
            { text: 'Closed Captioning', supported: false},
            { text: 'Mobile support', supported: true},
            { text: 'Ad (Pre/Midroll) detection', supported: false},
            { text: 'Audio Fingerprinting', supported: false},
            { text: 'AI video processing', supported: false}
          ]
        },
        {
          name: 'Shaka Player',
          id: 'shaka',
          action: {
            url: '/players?player=',
            text: 'See Examples'
          },
          features: [
            { text: 'Play/Pause/Seek/RW/FF', supported: true},
            { text: 'Volume Up/Down', supported: true},
            { text: 'Full Screen', supported: true},
            { text: 'Picture In Picture', supported: false},
            { text: 'Streaming', supported: false},
            { text: 'Play speed 0.5x to 2x', supported: false},
            { text: 'Closed Captioning', supported: false},
            { text: 'Mobile support', supported: false},
            { text: 'Ad (Pre/Midroll) detection', supported: false},
            { text: 'Audio Fingerprinting', supported: false},
            { text: 'AI video processing', supported: false}
          ]
        }]
      },
      features: {
        header: 'Automatic content enhancement',
        features: [          
          {
            icon: 'flaticon-tap',
            title: 'Overlaid interactives',
            text: 'Smart Content is automatically overlaid programmatically over your videos.'
          },
          {
            icon: 'flaticon-fingerprint',
            title: 'More watch time',
            text: 'Your audience will spend more time when you show them meaningful content.'
          },
          {
            icon: 'flaticon-notification',
            title: 'Additional revenue',
            text: 'Forget forced-prerolls; show people relevant content while they\'re watching!'
          },
          {
            icon: 'flaticon-place',
            title: 'Location relevant',
            text: 'Users are 2x as likely to report location to provide better content.'
          },
          {
            icon: 'flaticon-settings',
            title: 'You control everything',
            text: 'Hundreds of settings, themes and events to choose from, or, go with defaults.'
          },
          {
            icon: 'flaticon-language',
            title: 'Pull content from anywhere',
            text: 'Link over 40 different platforms including news outlets, storefronts, polls and more.'
          }
        ]
      },
      discover: {
        image: 'assets/img/example.jpg',
        title: 'How it works...',
        subtitle: 'Turnkey Web will use settings you\'ve configured, or try to find sensible default choices. It will then find all videos matching those settings on your page and put our overlay on top. It will use the video file name being played to link your content to settings on the SourceSync platform.',
        features: [
          'The entire overlay process occurs within a single RAF (1/60th of a second) on even the slowest mobile devices after files are loaded, meaning no ugly blinking and everything is seamless.',
          'The overlay is just a transparent iFrame. It works on all devices and platforms and meets Banking and Government security standards.',
          'When your users tap our frame, we re-emit that tap right to your existing player for normal processing. All your functions and analytics will work as expected.',
          'Using the open standard "Player.js" protocol, we emit everything that goes on in our layer to your page for additional processing.',
          'We emit details about the user like their location, and autofill information if your settings allow it.',
          'We will auto-detect your analytics and if you allow it, we will fill you in with all the extra info automatically.',
          'If your player is supported, there is no other work except adding our script and your account id to your page!'
        ]
      }
    }
  }
}
</script>

<style>

</style>